export default "__VITE_ASSET__DKrZvwrg__"